
import React from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Calendar } from '@/components/ui/calendar';
import { cn } from '@/lib/utils';

interface RetentionFiltersProps {
  state: string;
  setState: (value: string) => void;
  courseType: string;
  setCourseType: (value: string) => void;
  retentionDate: string;
  setRetentionDate: (value: string) => void;
}

export function RetentionFilters({
  state,
  setState,
  courseType,
  setCourseType,
  retentionDate,
  setRetentionDate
}: RetentionFiltersProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="space-y-2">
        <Label htmlFor="stateFilter">State Filter (Optional)</Label>
        <Select value={state} onValueChange={setState}>
          <SelectTrigger id="stateFilter">
            <SelectValue placeholder="All States" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All States</SelectItem>
            <SelectItem value="FL">Florida</SelectItem>
            <SelectItem value="CA">California</SelectItem>
            <SelectItem value="TX">Texas</SelectItem>
            <SelectItem value="NY">New York</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="courseTypeFilter">Course Type Filter (Optional)</Label>
        <Select value={courseType} onValueChange={setCourseType}>
          <SelectTrigger id="courseTypeFilter">
            <SelectValue placeholder="All Course Types" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Course Types</SelectItem>
            <SelectItem value="BDI">BDI</SelectItem>
            <SelectItem value="ADI">ADI</SelectItem>
            <SelectItem value="TLSAE">TLSAE</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label>Retention Date</Label>
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className={cn(
                "w-full justify-start text-left font-normal",
                !retentionDate && "text-muted-foreground"
              )}
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {retentionDate ? format(new Date(retentionDate), "PPP") : "Pick a date"}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0">
            <Calendar
              mode="single"
              selected={new Date(retentionDate)}
              onSelect={(date) => setRetentionDate(date ? format(date, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd'))}
              initialFocus
              className="pointer-events-auto"
            />
          </PopoverContent>
        </Popover>
        <p className="text-xs text-muted-foreground">Certificates issued before this date will be archived</p>
      </div>
    </div>
  );
}
